export enum SOFTWARE_ENVIRONMENT {
  PROD = 'PROD',
  STG = 'STG',
  DEV = 'DEV',
}
